import { createStore } from 'zustand'

import { getLoginInfoApi } from '@eastcoal/api/auth/auth/getLoginInfo'

import { system } from '@eastcoal/common/config/system'

import { emitLoginEvent } from '../utils/event'

import { getAuthStoreInitialValue } from './inititalValue'
import { AuthStore } from './interface'

export const authStore = createStore<AuthStore>((set, get) => {
  const queryLoginDetail = async () => {
    try {
      const res = await getLoginInfoApi(undefined, {
        silence: true,
        ignore401: system.api.ignore401
      })
      if (!res) return
      set({
        ...res,
        logined: true
      })
      setTimeout(() => emitLoginEvent(get()), 0)
    } finally {
      set({
        loaded: true,
        reload: queryLoginDetail
      })
    }
  }
  queryLoginDetail()
  return getAuthStoreInitialValue()
})
